import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Smell"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.5 11.25V7.5H15V12.75H16.5C17.7426 12.75 18.75 13.7574 18.75 15C18.75 16.2426 17.7426 17.25 16.5 17.25H15.75V15.75H14.25V17.25C14.25 18.4926 13.2426 19.5 12 19.5C10.7574 19.5 9.75 18.4926 9.75 17.25V15.75H8.25V17.25H7.5C6.25736 17.25 5.25 16.2426 5.25 15C5.25 13.7574 6.25736 12.75 7.5 12.75H9V6.75C9 5.50736 10.0074 4.5 11.25 4.5H12V3H11.25C9.17893 3 7.5 4.67893 7.5 6.75V11.25C5.42893 11.25 3.75 12.9289 3.75 15C3.75 17.0711 5.42893 18.75 7.5 18.75H8.565C9.16249 20.1142 10.5107 20.9956 12 20.9956C13.4893 20.9956 14.8375 20.1142 15.435 18.75H16.5C18.5711 18.75 20.25 17.0711 20.25 15C20.25 12.9289 18.5711 11.25 16.5 11.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Smell.vue"]]);
